export default __webpack_public_path__ + "static/media/ic_wallet_24.4be97369.svg";